import { render, staticRenderFns } from "./DetailFormItem.vue?vue&type=template&id=bac83880&scoped=true"
import script from "./DetailFormItem.vue?vue&type=script&lang=js"
export * from "./DetailFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac83880",
  null
  
)

export default component.exports